<template>
  <b-row class="align-items-center">
    <b-col xs="12" md="6">
      <validation-observer
        ref="onlinePaymentFormValidator"
        #default="{ invalid }"
      >
        <b-form
          @submit.prevent="onlinePayment"
          ref="onlinePaymentForm"
          class="row"
        >
          <!-- first name -->
          <b-form-group
            label-for="firstName"
            label="First Name"
            class="col-12 col-md-6"
          >
            <validation-provider
              #default="{ errors }"
              name="First Name"
              vid="firstName"
              rules="required"
            >
              <b-form-input
                id="firstName"
                v-model="firstName"
                name="firstName"
                placeholder="John"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- last name -->
          <b-form-group
            label-for="lastName"
            label="Last Name"
            class="col-12 col-md-6"
          >
            <validation-provider
              #default="{ errors }"
              name="Last Name"
              vid="lastName"
              rules="required"
            >
              <b-form-input
                id="lastName"
                v-model="lastName"
                name="lastName"
                placeholder="Doe"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- email -->
          <b-form-group label="Email" label-for="email" class="col-12">
            <validation-provider
              #default="{ errors }"
              name="Email"
              vid="email"
              rules="required|email"
            >
              <b-form-input
                id="email"
                v-model="email"
                name="email"
                placeholder="john@example.com"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <!-- phone number -->
          <b-form-group
            label="Enter Phone Number"
            label-for="phone"
            class="col-12"
          >
            <validation-provider
              #default="{ errors }"
              name="Phone"
              vid="phone"
              rules="required|integer"
            >
              <b-form-input
                id="phone"
                type="tel"
                v-model="phone"
                placeholder="71405912"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- last name -->
          <b-form-group
            label-for="amount"
            label="Amount in Botswana Pula (BWP)"
            class="col-12"
          >
            <validation-provider
              #default="{ errors }"
              name="Amount"
              vid="amount"
              rules="required|integer|min:2"
            >
              <b-form-input
                id="amount"
                v-model.number="amount"
                type="number"
                name="amount"
                placeholder="XXXX"
              />
              <small class="text-mute"
                >Minimum transaction amount is BWP 50</small
              >
              <br />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Form Actions -->
          <div class="col-12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
              :disabled="invalid || formIsLoading"
              :class="{ disabled: invalid }"
            >
              <b-spinner small v-if="formIsLoading" />
              <span v-if="formIsLoading">&nbsp;</span>
              Top-Up
            </b-button>
          </div>
        </b-form>
      </validation-observer>

      <div ref="paymentCheckout" v-html="proceedPaymentCheckoutHtml"></div>
    </b-col>
  </b-row>
</template>


<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, integer, min } from "@validations";

import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BSpinner,
  BCard,
  BCardText,
  BCardTitle,
  BProgress,
} from "bootstrap-vue";
import axios from 'axios'
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { $themeConfig } from '@themeConfig'



export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BSpinner,
    BCard,
    BCardText,
    BCardTitle,
    BProgress,

    // validations
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  emits:["proceed-to-checkout"],
  data() {
    return {
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      amount: null,
      proceedPaymentCheckoutHtml: null,
      formIsLoading: false,
      required,
      integer,
      min,
    };
  },
  methods: {
    onlinePayment() {
      const { tylersoftPaymentUri, tylersoftServiceId, tylersoftCountryCode, tylersoftCallbackUrl } = $themeConfig.app

      this.formIsLoading = true;
      this.$refs.onlinePaymentFormValidator.validate().then((success) => {
        if (success) {
          this.$http
            .post("/credits/online-payment", {
              phone: this.phone,
              amount: this.amount,
              first_name: this.firstName,
              last_name: this.lastName,
              email: this.email,
            })
            .then((response) => {
              const data = response.data.data
              axios.post(tylersoftPaymentUri,{
                amount: data.amount,
                accountno: data.phone,
                serviceid: tylersoftServiceId,
                msisdn: data.phone,
                currencycode: tylersoftCountryCode,
                name: data.first_name + " " + data.last_name,
                transactionid: data.transaction_id,
                callbackurl: tylersoftCallbackUrl,
                email: data.email,
              }, {
                headers:{
                  "Content-Type": "application/json",
                  "Authorization": "Bearer " + data.token,
                }
              })
              .then((res) => {
                // this.$nextTick(() => {
                //   this.$refs.onlinePaymentFormValidator.reset();
                // });
                // this.$refs.onlinePaymentForm.reset();
                this.proceedPaymentCheckoutHtml = res.data;
                setTimeout(() => {
                  this.$refs.paymentCheckout.querySelector('form').submit()
                }, 100);
                // this.formIsLoading = false;
              })
              .catch((err) =>{
                console.log("Error");
                console.log(err);
                this.formIsLoading = false;
              })
            })
            .catch((error) => {
              for (let err of error.response.data.error) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: err,
                    icon: "AlertCircleIcon",
                    variant: "danger",
                  },
                });
              }
              this.formIsLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.icon-status {
  width: 2rem;
  height: 2rem;
}
</style>